export enum Lang {
  EN = 'en',
  PTBR = 'pt-BR',
  DE = 'de',
}
